export default {
    notes: [],
    addStatus: null,
    listStatus: null,
    updateStatus: null,
    deleteStatus: null
}